module.exports = __webpack_public_path__ + "static/media/reddit.6cfc95e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/reddit.svg
// module id = 3426
// module chunks = 7